import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAlignVerticalCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"align-vertical-center, alignment"} maskId="square-filled-radius-0-stroke-1-IconAlignVerticalCenter"><path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM7 11.5V12.5H17V11.5H7Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAlignVerticalCenter;
